import type {SyncIntegration} from '@cohort/merchants/apps';
import PostgresqlSyncConfigComponent from '@cohort/merchants/apps/postgresql/sync/SyncConfigComponent';
import type {PostgresqlSyncStruct} from '@cohort/shared/apps/postgresql/sync';
import {PostgresqlSyncIntegrationSpec} from '@cohort/shared/apps/postgresql/sync';

export const PostgresqlSyncIntegration: SyncIntegration<PostgresqlSyncStruct> = {
  spec: PostgresqlSyncIntegrationSpec,
  syncConfigComponent: PostgresqlSyncConfigComponent,
};
